import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface IFilterVisibility {
    wasSeen: boolean;
    filtersModalOpened: boolean;
}

export const filtersVisibilitySlice = createSlice({
    name: "filtersVisibility",
    initialState: {
        wasSeen: false,
        filtersModalOpened: false
    },
    reducers: {
        setFiltersShown: (state, action: PayloadAction<Pick<IFilterVisibility, "wasSeen">>) => {
            state.wasSeen = action.payload.wasSeen;
        },
        filtersModalOpened: (state, action: PayloadAction<Pick<IFilterVisibility, "filtersModalOpened">>) => {
            state.filtersModalOpened = action.payload.filtersModalOpened;
        }
    }
});

export const {setFiltersShown, filtersModalOpened} = filtersVisibilitySlice.actions;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface IFilterVisibility {
    wasSeen: boolean;
    filtersModalOpened: boolean;
}

export const filtersVisibilitySlice = createSlice({
    name: "filtersVisibility",
    initialState: {
        wasSeen: false,
        filtersModalOpened: false
    },
    reducers: {
        setFiltersShown: (state, action: PayloadAction<Pick<IFilterVisibility, "wasSeen">>) => {
            state.wasSeen = action.payload.wasSeen;
        },
        filtersModalOpened: (state, action: PayloadAction<Pick<IFilterVisibility, "filtersModalOpened">>) => {
            state.filtersModalOpened = action.payload.filtersModalOpened;
        }
    }
});

export const {setFiltersShown, filtersModalOpened} = filtersVisibilitySlice.actions;
